<div class="row justify-content-center">
  <div class="col-6">
      <h5>{{ 'editHospitalAllowedTypes' | localize }}</h5>
      <span>{{ localizationKey('editHospitalAllowedTypesText') | localize }} </span>

    <div *ngIf="feature311Released" class="grid grid-striped">

      <div class="row">
        <div class="col-8">

        </div>
        <div class="col-2 text-center">
          {{ localizationKey("editHospitalAllowedTypesHeaderNonHome") | localize }}
        </div>
        <div class="col-2 text-center">
          {{ localizationKey("editHospitalAllowedTypesHeaderHome") | localize }}
        </div>
      </div>

      <div *ngFor="let type of allMeasurementTypes" class="row">
        <div class="col-8">
          {{ getMeasurementTypeLocalizationKey(type) | localize }}
        </div>
        <div class="col-2 text-center">
          <label class="w-100" [attr.for]="'allowed-type-' + type.toString()">
            <input
              [attr.id]="'allowed-type-' + type.toString()"
              type="checkbox"
              [ngModel]="allowedTypes[type]"
              (ngModelChange)="onTypeChange(type, $event)"
              [attr.data-testid]="'allowed-type-' + type.toString()"/>
          </label>
        </div>
        <div class="col-2 text-center">
          <label class="w-100" [attr.for]="'allowed-home-type-' + type.toString()">
            <input
              [attr.id]="'allowed-home-type-' + type.toString()"
              type="checkbox"
              [ngModel]="allowedHomeTypes[type]"
              (ngModelChange)="onHomeTypeChange(type, $event)"
              [attr.data-testid]="'allowed-home-type-' + type.toString()"/>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="!feature311Released" class="grid grid-striped">
      <div *ngFor="let type of allMeasurementTypes" class="row">
        <div class="col-12">
          <label class="w-100" [attr.for]="'allowed-type-' + type.toString()">
            <input
              [attr.id]="'allowed-type-' + type.toString()"
              type="checkbox"
              [ngModel]="allowedTypes[type]"
              (ngModelChange)="onTypeChange(type, $event)"
              [attr.data-testid]="'allowed-type-' + type.toString()"/>
            {{ getMeasurementTypeLocalizationKey(type) | localize }}
          </label>
        </div>
      </div>
    </div>

  </div>

</div>
